import { render } from "./Pass.vue?vue&type=template&id=ecea2054"
import script from "./Pass.vue?vue&type=script&lang=js"
export * from "./Pass.vue?vue&type=script&lang=js"

import "./Pass.vue?vue&type=style&index=0&id=ecea2054&lang=scss"
script.render = render

export default script